export const useAndroidShareImage = () => {
  const androidApp = typeof window === 'object' ? window.StitchFixAndroidApp : undefined;
  const canShareImage = !!androidApp?.shareImage;
  const shareImage = canShareImage ? (url: string) => {
    try {
      androidApp!.shareImage!(url);
    } catch (err) {
      console.error('Android shareImage failed:', err);
    }
  } : undefined;
  return {
    canShareImage,
    shareImage
  };
};